import type { BaseModelAttributes } from './base';
import { I18nLabels } from './common';
import { Locale } from './locale';

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user'
}

export enum VipLevel {
  NONE = 'none',
  VIP1 = 'vip1',
  VIP2 = 'vip2'
}

export const VipLevelLabels: I18nLabels<VipLevel> = {
  [VipLevel.NONE]: { [Locale.ZH_CN]: '无会员', [Locale.EN_US]: 'No VIP' },
  [VipLevel.VIP1]: { [Locale.ZH_CN]: 'VIP1', [Locale.EN_US]: 'VIP1' },
  [VipLevel.VIP2]: { [Locale.ZH_CN]: 'VIP2', [Locale.EN_US]: 'VIP2' },
};

export const UserRoleLabels: I18nLabels<UserRole> = {
  [UserRole.ADMIN]: { [Locale.ZH_CN]: '管理员', [Locale.EN_US]: 'Admin' },
  [UserRole.USER]: { [Locale.ZH_CN]: '用户', [Locale.EN_US]: 'User' },
};

export interface IUser extends BaseModelAttributes {
  username: string;
  email: string;
  password: string;
  name: string;
  role: UserRole;
  vipLevel?: VipLevel;
  tenantId?: string;
  isTenantAdmin?: boolean;
}

export interface UpdateProfileRequest {
  name: string;
  email: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

// 认证相关类型
export interface LoginRequest {
  email: string;
  password: string;
  captchaId: string;
  captchaCode: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  name: string;
  tenantId?: string;
}

export interface AuthResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
  };
}

export interface CaptchaChallengeResponse {
  captchaId: string;
  imageDataUrl: string;
  expiresInSeconds: number;
}

export interface JwtPayload {
  id: string;
  userId: string;
  email: string;
  role: UserRole;
  vipLevel?: VipLevel;
  tenantId?: string;
  isTenantAdmin?: boolean;
  iat?: number;
  exp?: number;
}

// 用户响应类型（不包含敏感信息）
export interface UserResponse {
  id: string;
  username: string;
  email: string;
  name: string;
  role: UserRole;
  vipLevel?: VipLevel;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  createdBy: string;
  updatedBy?: string;
  coinBalance?: number;
}
